const LABELS = {
   COMMON: {
    requiredField: 'Required Field',
    cancel: "CANCEL",
    contactUs: "Contact us",
   },
    ORDER_INFO: {
      accountBalance: "Account Balance: {{amount}}",
      amountDue: "Amount Due: {{amount}}",
      subTotal: "Subtotal: {{amount}}",
      bagTotal: "Bag Total: {{amount}}",
      promoApplied: "Promo Applied: {{amount}}",
      tax: "Tax: {{amount}}",
      orderTotal: "Order Total: {{amount}}",
    },
    CART: {
      modalTitle: "Your Shopping Cart",
      bannerError: "Oh snap! You got an error!",
      shellBannerError: "Unable to Complete Your Request",
      shellBannerErrorMessage: "Something went wrong while processing your request. Please try again in a moment.",
      bannerErrorMessage: "It looks like we are unable to complete your order at this time. Please try in our Mobile App",
      priceOverLimitError: "Orders over $200 cannot be placed. Please remove items or visit {{cateringSite}} for catering orders.",
      noItems: 'No items in cart.',
      subtotal: "Subtotal",
      addItems: "Add Items",
      proceedToCheckout: "Proceed To Checkout",
      checkout: "Checkout",
      storeIsNotAcceptingOrders: "Store is not accepting online order at this moment.",
      leaveOrderTitle: "Leave your order?",
      leaveOrderMessage: "Are you sure you want to leave? The items in your cart will not be saved.",
      stay: "STAY",
      leave: "LEAVE",
    },
    REWARDS: {
      checkoutDiscount: "Discount will be applied at the checkout.",
      rewardSelectProduct: "Choose one to add to your order.",
      rewardExpiredError: "Discount can not be applied because the reward expires before the pickup date.",
      rewardExpired: "This reward expires before your selected date",
      rewardExpiredButton: "UNAVAILABLE",
      rewardNotAvailable: "Reward Not Available",
      rewardExpiredAlert: "Your reward is not available for the pickup date you selected. You can continue without this reward or change your date.",
      redeemTextPart1: "Are you sure you would like to redeem ",
      redeemTextPart2: " for a Free Bakery Item? Once you’ve redeemed your reward, you may then add your desired reward item to your order.",
      termsAndConditions: "Terms and Conditions",
      addToOrder: "ADD TO ORDER",
      yesAddToOrder: "YES, ADD TO ORDER",
      yesRedeem: "YES, REDEEM",
      redeemSuccessHeader: "Success! You’ve redeemed a ",
      failedToRedeem: "Failed to redeem ",
      notNow: "NOT NOW",
      redeem: "REDEEM",
      redeemRewards: "Redeem Rewards",
      myRewards: "My Rewards",
      redeemFailed: "Redeem Failed! Please try again later.",
      readyToUse: "Ready to Use",
      viewDetails: "VIEW DETAILS",
      close: "CLOSE",
      cancel: "CANCEL",
      expires: "Expires",
      back: "BACK",
      proceed: "PROCEED",
    },
    FUTURE_ORDERS: {
      pickupQuestion: "When do you want it ready?",
      emptyPickupType: "SELECT TYPE",
      emptyPickupDate: "SELECT DATE",
      emptyPickupTime: "SELECT TIME",
      storeClosedToday: "This store has closed for the day.",
      clickLater: "Click 'Later' to schedule an order.",
      pickUpNotAvailable: "Store is not accepting online orders at this time.",
      clickBrowse: "Click Browse Menu to view our in-store menu!",
      later: "Later",
      asap: "ASAP",
      today: "today",
      tomorrow: "tomorrow",
      storeClosed: "This store is permanently closed. Please choose a different location to place an order.",
    },
    LOGIN: {},
    RECENT_ORDERS: {
      orders: "ORDERS",
      recentOrders: "RECENT ORDERS",
      noRecentOrders: "There are no recent orders.",
      reOrderNow: "Re-Order Now",
      pendingOrders: "PENDING ORDERS",
      noPendingOrders: "No pending orders.",
      changeLocation: "Choosing a new location will clear the contents of your cart. Do you wish to proceed?",
      notApply: 'NA',
      viewMoreOrders: "View More Orders",
    },
    SIGNUP: {
        firstName: "First Name",
        lastName: "Last Name",
        emailAddress: "Email Address",
        phoneNumber: "Phone Number",
        birthday: "Birthday",
        zipCode: "Zip Code",
        password: "Password",
        confirmPassword: "Confirm Password",
        emailNotifications: "Email Notifications",
        emailConsent: "I would like to be notified of my rewards and other special offers by email",
        cateringEmail: "Catering Notifications",
        cateringConsent: "I would like to be notified of my catering offers by email",
        smsNotifications: "SMS Notifications",
        smsConsent: "I would like to receive periodic and recurring SMS texts from Einstein Bros. Bagels and its agents.",
        signUpSmsDataRates: "I understand that such texts will be delivered to the cellular telephone number I have provided above for which I am an authorized user, and that the messages may be delivered using automated technology (8:00 AM to 9:00 PM in the zip code provided when creating my rewards account). I further understand that the messages will be about Einstein Bros. Bagels products and offerings, including but not limited to marketing of goods and services that may be of interest to me, surveys regarding my experiences or preferences, updates regarding orders or deliveries, program sign-up information, and educational notifications. I acknowledge that consent is not required to purchase any goods or services, that I can reply “STOP,” “END,” “CANCEL,” “UNSUBSCRIBE,” or “QUIT” to any message to stop receiving texts from that number, and that I can reply “HELP” for help regarding the texting program. I understand that message and data rates may apply.",
        signUpReadTerms: "Read the terms of use carefully. By creating an account, you agree to resolve all disputes through binding individual arbitration, to waive your right to file a lawsuit in court, and to bring or participate in any class action. There is no judge or jury in arbitration, and discover procedures and appellate rights are more limited than in court.",
        signUpReadPrivacy: "By clicking “JOIN NOW,” I agree to the terms and conditions selected above, including to arbitrate any disputes on an individual basis as described in the Terms of Use, and to the collection, use, and disclosure of my data as described in the Privacy Policy",
        signUpByApplying: "By applying these settings, you agree to accept :terms, :privacy, and :financialIncentive.",
    },
    CHANGE_PASSWORD: {
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmNewPassword: "Confirm New Password",
    },
    GIFT_CARD_TRANSFER: {
      giftCardTransfer: "Gift Card Transfer",
      transfer: 'TRANSFER',
      redeem: "REDEEM",
      giftCardNumber: 'Gift Card Number',
      pin: 'Pin',
      accountBalance: 'Account Balance',
      balanceTransferContent: "Enter your gift card number and PIN (found on the back of your card or in your e-gift email) to view your balance and transfer to your {{brandTitle}} account.",
      transferBalance: "Transfer Balance",
      unableToTransfer: "Unable to Transfer!",
      transferGiftCard: 'Transfer Gift Card',
      gitCardBalance: "Your gift card ending in {{cardNumber}} has {{amount}}. Transfer the entire amount to your account?",
      gitCardEmpty: "Your gift card ending in {{cardNumber}} has {{amount}}.",
      balanceExceeded: "Your gift card ending in {{cardNumber}} has {{amount}}, but transferring it would exceed your $200 account balance limit.",
      giftcardTransferSuccess: "Gift card transferred successfully.",
      giftcardTransferSuccessSubText: "{{amount}} was added to your account.",
      giftcardTransferError: "Gift card transfer failed.",
      giftcardTransferErrorSubText: "Please try again.",
    },
    GENERAL_INFO: {
      changePhoneNumberModalHeader: "Text Messages",
      changePhoneNumberModalContent: "This number may be used for SMS text alerts. If you change your number, you’ll need to confirm it again to continue receiving messages.",
      changePhoneNumberModalConfirmButton: "OK",
      updatedPhoneNumberModalHeader: "Phone Number Changed",
      updatePhoneNumberModalContent: "We noticed you’ve changed your account phone number. You may need to verify your number if you are enrolled in SMS alerts.",
    },
    NOTIFICATIONS: {
      emailNotificationLabel: "Email Notifications",
      emailNotificationSubLabel: "Emails about my rewards and other special offers",
      emailNotificationModalHeader: "Unsubscribe from Email Notifications",
      emailNotificationModalSubHeader: "Are you sure you would like to proceed with unsubscribing from Email Notifications?",
      emailCateringNotificationLabel: "Catering Email Notifications",
      emailCateringNotificationSubLabel: "Emails about catering offers",
      emailCateringNotificationModalHeader: "Unsubscribe from Catering Email Notifications",
      emailCateringNotificationModalSubHeader: "Are you sure you would like to proceed with unsubscribing from Catering Email Notifications?",
      emailCateringNotificationModalBody: "Please note, transactional emails including receipts for online & app orders, will continue to be sent to the email associated with the order.",
      smsNotificationLabel: "SMS Notifications",
      smsNotVerifiedSubtitle: "Please respond with 'YES' to the text message you will receive shortly to verify your enrollment",
      smsVerifiedSubtitle: "Text messages about my rewards and other special offers",
      smsNotificationModalHeader: "Opt-Out from SMS Notifications",
      smsNotificationModalSubHeader: "Are you sure you would like to proceed with opting out from SMS Notifications?",
      smsNotificationModalBody: "You will no longer receive text messages about my rewards and other special offers.",
      smsVerified: "Verified",
      smsVerificationPending: "Verification Pending",
      subscribe: "SUBSCRIBE",
      nevermind: "NEVERMIND",
      unsubscribe: "UNSUBSCRIBE",
      resubscribe: "RESUBSCRIBE",
      optIn: "OPT-IN",
      optOut: "OPT-OUT",
      emailUnsubscribedMsg: "You’ve successfully unsubscribed from Email Notifications",
      emailSubscribedMsg: "You’ve successfully subscribed to Email Notifications",
      cateringUnsubscribedMsg: "You’ve successfully unsubscribed from Catering Email Notifications",
      cateringSubscribedMsg: "You’ve successfully subscribed to Catering Email Notifications",
      smsOptOutMsg: "You’ve successfully opted out of SMS Notifications",
      smsLegalMsg: "By opting in. I understand that such texts will be delivered to the cellular telephone number I have provided above for which I am an authorized user, and that the messages may be delivered using automated technology (8:00 AM to 9:00 PM in the zip code provided when creating my rewards account). I further understand that the messages will be about Einstein Bros. Bagels products and offerings, including but not limited to marketing of goods and services that may be of interest to me, surveys regarding my experiences or preferences, updates regarding orders or deliveries, program sign-up information, and educational notifications. I acknowledge that consent is not required to purchase any goods or services, that I can reply “STOP,” “END,” “CANCEL,” “UNSUBSCRIBE,” or “QUIT” to any message to stop receiving texts from that number, and that I can reply “HELP” for help regarding the texting program. I understand that message and data rates may apply.",
    },
    PERSONAL_INFO: {
      firstName: 'First Name',
      lastName: 'Last Name',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      birthday: 'Birthday',
      city: 'City',
      zipCode: 'Zip Code',
      state: 'State',
      saveChangesButton: 'SAVE CHANGES',
      please: 'Please',
      emailAddressChange: 'in order to change your email address.',
    },
    PICKUP_INFO: {
      walkIn: "WALK-IN",
      driveThru: "DRIVE-THRU",
      curbside: "CURBSIDE",
      walkInDescription: "Head into the store and pick up your order.",
      driveThruDescription: "Jump in the drive-thru line and let us know you have a mobile order waiting.",
      curbsideDescription: "Place your order and let us know when you arrive. We will bring your items to your vehicle.",
    },
} as const;

/**
 * Decouples Messages with components.
 * Retrieves an error message based on the specified section and message key from `LABELS`.
 * This function can be extended for future localization (e.g., i18n) to return localized messages.
 * @param section - The section within `LABELS` (e.g., 'SIGNUP').
 * @param messageKey - The specific message key within the section (e.g., 'firstName').
 * @returns The corresponding label as a string.
 */
export function getLabel<
  Section extends keyof typeof LABELS,
  MessageKey extends keyof typeof LABELS[Section],
>(
section: Section,
  messageKey: MessageKey,
  replacements?: Record<string, string | number>,
): string {
    /*Any logic for localization of literals for future can be done here*/
  let label = LABELS[section][messageKey] as string;

  if (replacements) {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const key in replacements) {
      label = label.replace(`{{${key}}}`, String(replacements[key]));
    }
}
return label;
}
export default LABELS;
